export default {
      id: "hm-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#hm",
      toString: function () {
        return this.url;
      }
    }